import HmEventRegistry from './../model/HmEventRegistry';
import CoreAjax from './CoreAjax';
/*
 * Common Ajax for the application.
 * Depends on React fetch
 *
 */
 var HmAjax = function(url,data,headers){

 	let maskEnabled = false;
 	let maskType = null;
 	var availableMethods = ['GET','POST','PUT','DELETE'];
 	var dataStr = "";

 	if(typeof data === 'object'){
 		try{
 			dataStr = JSON.stringify(data);
 		}catch(e){
 			console.error("Error occurred while processing the data:",e);
 		}
 	}else{
 		console.warn("Data is not in the form of an object");
 	}

 	this.mask = function(inMaskType=null){
 		maskEnabled = true;
 		maskType = inMaskType;

 		return this;
 	}

 	this.get = function(success, failure){
 		this.connect('GET',success, failure);
 	}

 	this.post = function(success, failure){
 		this.connect('POST',success, failure);
 	}

 	this.put = function(success, failure){
 		this.connect('PUT',success, failure);	
 	}

 	this.delete = function(success, failure){
 		this.connect('DELETE',success, failure);		
 	}

 	this.connect = function(method, success, failure){

 		var successCallback = function(result, opts){
 			if(maskEnabled){
 				HmEventRegistry.fireEvent("HIDE_MASK");
 			}
 			
 			if(!sessionValid(result)){
 				HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
 				return;
 			}

 			if(!systemErrCheck(result)){
 				HmEventRegistry.fireEvent("ERROR_PROMPT",buildErrorObj(result,url));
 				return;
 			}

 			if(!isValidContest(result)){
 				HmEventRegistry.fireEvent("INVALID_PROMPT_PROMPT",buildInvalidContestObj(result,url));
 				return;
 			}


 			if(opts && opts.timeTakenInSecs >= 2){
 				//Trigger NET_CHECK to check internet
 				HmEventRegistry.fireEvent("NET_CHECK");
 			}

 			try{
 				if(typeof success === "function"){
 					success.apply(this,[result, opts]); 
 				}
 			}catch(e){
 				console.error("Error occurred while calling the success handler:",e);
 			}
 		}

 		var failureCallback = function(error, opts){
 			if(maskEnabled){
 				HmEventRegistry.fireEvent("HIDE_MASK");
 			}
 			
 			if(!sessionValid(error)){
 				HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
 				return;
 			}

 			//Trigger NET_CHECK to check internet
 			HmEventRegistry.fireEvent("NET_CHECK");

 			try{
 				if(typeof failure === "function"){
 					failure.apply(this,[error, opts]);
 				}else{
					//Trigger default failurePrompt	
					HmEventRegistry.fireEvent("ERROR_PROMPT",buildErrorObj(503,url));	
				}
			}catch(e){
				console.error("Error occurred while calling the failure handler:",e);
			}
		}


		if(availableMethods.indexOf(method) === -1){
			//if method not defined, default is applied
			method = availableMethods[0];
		}

		if(maskEnabled){
			HmEventRegistry.fireEvent("SHOW_MASK", {maskType:maskType});	
		}
		
		new CoreAjax(url,data,headers).connect(method,successCallback,failureCallback);

	}
	
	var sessionValid = function(response){
		try{
			if(typeof response === "object" && Object.keys(response).length > 0){
				if(typeof response.sessionValid !== "undefined" && response.sessionValid === "false"){
					return false;
				}
			}
		}catch(e){
			console.error(e);
		}

		return true;
	};


	var systemErrCheck = function(response){
		try{
			if(typeof response === "object" && Object.keys(response).length > 0){
				if(typeof response.error !== "undefined" && (response.error === true || response.error === "true")){
					return false;
				}
			}
		}catch(e){
			
		}

		return true;
	}

	const isValidContest = function(response){
		try{
			if(response && response.status === "forbidden" && response.message === "invalid_contest"){
				return false;
			}
		}catch(e){

		}

		return true;
	}

	const buildInvalidContestObj = function(response){
		let errObj = {};
		try{
			errObj["title"] = "invalid_contest.title";
			errObj["msg"] = "invalid_contest.msg";
			errObj["status_code"] = 403;

			errObj["available_contests"] = [];

			if(response.schoolContests){
				if(response.schoolContests.includes(",")){
					response.schoolContests.split(",").map((each, idx) => {
						if(each){
							errObj["available_contests"].push(each);
						}
					});
				}else{
					errObj["available_contests"].push(response.schoolContests);
				}
			}
		
			return errObj;
		}catch(e){
			console.error("Error building Invalid COntest response",e);
		}
	}

	var buildErrorObj = function(response,url){
		var errObj = {};

		if(typeof response === "object"){
			try{
				if(typeof response === "object" && Object.keys(response).length > 0){
					if(typeof response.error !== "undefined" && (response.error === true || response.error === "true")){
						errObj["title"] = "500.title";
						errObj["msg"] = "500.msg";
						errObj["status_code"] = 500;
						errObj["reference_id"] = response.reference_id;
						if(url){
							errObj["url"] = url;
						}
					}
				}
			}catch(e){}
		}else if(response){
			//Error for 503 - Service Unavailable
			if(response === 503){
				errObj["title"] = "503.title";
				errObj["msg"] = "503.msg";
				errObj["status_code"] = 503;
				if(url){
					errObj["url"] = url;
				}
			}
		}

		return errObj;
	}

}

export default HmAjax;


// WEBPACK FOOTER //
// ./src/util/HmAjax.js